import React, { useContext, useEffect, useState } from "react";
import "./Buy_sell_Btns.css";
import { Context } from "../../../../../utils/context";
import Right_End_Toolbar from "../Right_End_Toolbar";

const Buy_sell_Btns = ({
  latestAmount,
  sellOnClick,
  BuyOnClick,
  setPrice,
  price,
}) => {
  const { buyOrSale, setBuyOrSale } = useContext(Context);
  const [activeBtn, setActiveBtn] = useState("Market");
  const [activeConfirmBtn, setActiveConfirmBtn] = useState("Cancel");

  const leftPercent = 50;
  const rightPercent = 100 - leftPercent;

  const [lastClick, setLastClick] = useState(Date.now());

  const handleSellClick = () => {
    setBuyOrSale("sell");
    setPrice(latestAmount);
    setLastClick(Date.now());
    sellOnClick();
  };

  const handleBuyClick = () => {
    setBuyOrSale("buy");
    setPrice(latestAmount);
    setLastClick(Date.now());
    BuyOnClick();
  };

  useEffect(() => {
    console.log("Sell clicked or price updated:", price);
  }, [lastClick]);

  return (
    <section className="Buy_sell_Btns">
      <div className="blue_bg_div">
        <div className="sell_buy_div">
          <div className="text_betwn_div">
            <p className="text">{latestAmount || 0} $</p>
          </div>

          <div
            className={`byu_outer_div sell_outer_div ${
              buyOrSale === "buy" ? "active" : ""
            }`}
            onClick={handleBuyClick}
          >
            <div className="byu_div sell_div">
              <p className="title">Buy</p>
              <p className="value">{latestAmount} $ </p>
            </div>
          </div>

          <div
            className={`sell_outer_div ${buyOrSale === "sell" ? "active" : ""}`}
            onClick={handleSellClick}
          >
            <div className="byu_div sell_div">
              <p className="title">Sell</p>
              <p className="value">{latestAmount} $ </p>
            </div>
          </div>
        </div>

        <div className="progress_div">
          <div className="dual_progress_container"></div>
        </div>
      </div>
    </section>
  );
};

export default Buy_sell_Btns;
